let paypalInstance = null;

const getBraintreePaypalInstance = () => {
  if (paypalInstance === null) {
    throw new Error('Paypal not initialized');
  }

  return paypalInstance;
};

export const initBraintreePaypalInstance = (authorization: string) =>
  import(/* webpackChunkName: "braintree-web" */ 'braintree-web').then(
    ({ default: braintree }) =>
      braintree.client
        .create({
          authorization
        })
        .then(clientInstance =>
          braintree.paypal.create({
            client: clientInstance
          })
        )
        .then(instance => {
          paypalInstance = instance;
          return instance;
        })
  );

export default getBraintreePaypalInstance;
